import Model from './service_list.model'

let storeContent = utils.generateStore({
   Model,
   service_lists: [],
   selected_service_lists: [],
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async fetchServiceList(ctx) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'registry',
               action: 'list:registered_services',
               data: {},
               meta_data: {}
            })

            ctx.commit('service_lists', res.result.services);
         } catch (err) {
            throw err
         }
      },
      async fetchData(ctx) {
         try {
            await ctx.dispatch('fetchServiceList')
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
   }
};